<template>
  <div>
    <div
      ref="payerComponent"
      id="player"
      class="item"
      style="min-height:200px;"
      :key="height"
      v-bind:style="{ 'height': height}"
    ></div>
  </div>
</template>

<script>
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  props: {
    videoId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      height: 0,
      videoTime: 0
    };
  },
  computed: {
    playerRef() {
      return this.$refs.payerComponent.clientWidth;
    }
  },
  components: {},
  methods: {
    getPlayer() {
      const path = this.$global.endpoint + "/video/getplayer";
      axios
        .post(path, {
          videoId: this.videoId
        })
        .then(res => {
          this.playerHtml = res.data;
          var htmlContent = res.data;

          // run the scripts inside the dom node
          var $container = document.getElementById("player");
          $container.innerHTML = htmlContent;
          runScripts($container);

          /* helpers
           */
          // runs an array of async functions in sequential order
          function seq(arr, callback, index) {
            // first call, without an index
            if (typeof index === "undefined") {
              index = 0;
            }

            arr[index](function() {
              index++;
              if (index === arr.length) {
                callback();
              } else {
                seq(arr, callback, index);
              }
            });
          }

          // trigger DOMContentLoaded
          function scriptsDone() {
            var DOMContentLoadedEvent = document.createEvent("Event");
            DOMContentLoadedEvent.initEvent("DOMContentLoaded", true, true);
            document.dispatchEvent(DOMContentLoadedEvent);
          }

          /* script runner
           */

          function insertScript($script, callback) {
            var s = document.createElement("script");
            s.type = "text/javascript";
            if ($script.src) {
              s.onload = callback;
              s.onerror = callback;
              s.src = $script.src;
            } else {
              s.textContent = $script.innerText;
            }

            // re-insert the script tag so it executes.
            document.head.appendChild(s);

            // clean-up
            $script.parentNode.removeChild($script);

            // run the callback immediately for inline scripts
            if (!$script.src) {
              callback();
            }
          }

          // https://html.spec.whatwg.org/multipage/scripting.html
          var runScriptTypes = [
            "application/javascript",
            "application/ecmascript",
            "application/x-ecmascript",
            "application/x-javascript",
            "text/ecmascript",
            "text/javascript",
            "text/javascript1.0",
            "text/javascript1.1",
            "text/javascript1.2",
            "text/javascript1.3",
            "text/javascript1.4",
            "text/javascript1.5",
            "text/jscript",
            "text/livescript",
            "text/x-ecmascript",
            "text/x-javascript"
          ];

          function runScripts($container) {
            // get scripts tags from a node
            var $scripts = $container.querySelectorAll("script");
            var runList = [];
            var typeAttr;

            [].forEach.call($scripts, function($script) {
              typeAttr = $script.getAttribute("type");

              // only run script tags without the type attribute
              // or with a javascript mime attribute value
              if (!typeAttr || runScriptTypes.indexOf(typeAttr) !== -1) {
                runList.push(function(callback) {
                  insertScript($script, callback);
                });
              }
            });

            // insert the script tags sequentially
            // to preserve execution order
            seq(runList, scriptsDone);
          }
        })
        .catch(error => {
          // eslint-disable-next-line
          console.error(error);
        });
    }
  }
  ,
  mounted() {
    console.log('asdasdas');

    this.height = this.$refs.payerComponent.clientWidth/16*9 + "px";
    var vm = this;
    window.addEventListener("videoteca-loaded", function(evt) {
      videofrontVideoApi.on("progress", function(e, api, video) {
        var proportion =
          e.detail.vfplayer3.video.time / e.detail.vfplayer3.video.duration;
        vm.videoTime = proportion * 100;

        if (vm.videoTime == 100) {
          vm.$emit("updateTime", vm.videoTime);
        }
      });
    });
    this.getPlayer();
  },
  beforeDestroy: function() {
    this.$emit("updateTime", this.videoTime);
  }
};
</script>
